





















































































































































































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop} from 'vue-property-decorator';
import { Mutation, State, Getter } from 'vuex-class';
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import Label from './Label.vue';
import Axios from "axios";
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        Label,
    }
})
export default class ReviewInfo extends Vue {
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation setPage: Function;
    @Getter totalPrice: any;
    @State package: any;
    @State hotel: any;
    @State flight: any;
    @State bookingName: any;
    @State bookingPhone: any;
    email: string = '';
    @State country: any;
    @State countries: any[];
    @State numNights: any;
    @State numAdults: any;
    @State numChildren: any;
    @State remarks: any;
    @State adults: any;
    @State children: any;
    @Getter token: any;

    async mounted() {
        this.replaceRoute(['Booking', 'Reserve', 'Create Package', 'Information', 'Overview']);
        this.setPage(3);
        const response = await Axios.get(`http://${alzuhudLink}:8080/api/auth/me`, {
            params: {
                token: this.token,
            }
        });
        this.email = response.data.email;
        console.log(this.hotel);
        this.countries.find((item: any) => item.value === this.country);
    }
    /**
     *
     */
    constructor() {
        super();
    }
    beforeDestroy(): void {
        this.popRoute();
    }

    checkTicket(e: MouseEvent): void {
        alert('hello');
    }

    order(i: number): string {
        if (i === 11 || i === 12 || i === 13) {
            return i+'th';
        }
        switch (i % 10) {
            case 1:
                return i+'st';
            case 2:
                return i+'nd';
            case 3:
                return i+'rd';
            default:
                return i+'th';
        }
    }

    weekday: string[] = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];


    getDay(dateStr: string) {
        const date = new Date(dateStr).getDay();
        return this.weekday[date];
    }

    getDate(dateStr: string): string {
        return new Date(dateStr).toLocaleDateString('en-US', { month: 'long', day: 'numeric'});
    }

    split(str: string): string {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }
}
